import PropTypes from 'prop-types';
import classnames from 'classnames';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  () => ({
    root: {
      padding: '12px 16px',
      margin: '0 0 12px',
      borderRadius: 24,
      backgroundColor: 'rgba(224, 224, 224, 0.2)',
    },
  }),
  {
    name: 'Template',
  },
);

function Template({ className, children }) {
  const classes = useStyles();
  return <div className={classnames(classes.root, className)}>{children}</div>;
}

Template.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Template;
